/* eslint-disable no-useless-escape */
import React, { FC } from 'react'
import SignupLayout from '../../../layout'
import LeftImageSection from '../../../layout/leftImageSection'
import ConfirmationForm from './ConfirmationForm'

const Confirmation: FC = () => {
  const title = (): JSX.Element => {
    return (
      <div className="left-title">
        <p className="confirm-title">PUT YOUT SALES REACHOUTS ON AUTOPILOT.</p>
      </div>
    )
  }
  return (
    <SignupLayout>
      <LeftImageSection title={title()} img="/assets/images/2.jpg" />
      <ConfirmationForm />
    </SignupLayout>
  )
}
export default Confirmation
